import Attendee from "./Attendee";
import Prize from "./Prize";
import Utility from "@/shared/utility";
import axios from "axios";
import store from "@/store";
import Sponsor from "./Sponsor";
import constants from "../shared/constants";
import SponsorAnalytics from "./SponsorAnalytics";
import Speaker from "./Speaker";
import {doc, getFirestore, Timestamp, where, writeBatch} from "firebase/firestore";
import {
  deleteEventDoc,
  eventCollectionRef, eventDocRef, getBusinessCardsDoc,
  getCollectionRef, getDocById,
  getHttpsCallable,
  getQueryByCollectionName, postDocRef, setEventDoc, updateDocByName, updateEventDoc
} from "@/shared/firebase_utils";
import {my} from "timeago.js/lib/lang";

export default class Event {
  constructor({
    id = "",
    name = "",
    startDateTime = null,
    endDateTime = null,
    eventModifiedAt = null,
    linkPrivacy = "Public",
    hasPrizeDraw = false,
    minimumCardEntriesForPrizeDraw = 0,
    attendees = [],
    prizes = [],
    wizardProgress = "",
    currentTab = 0,
    businessProfileId = "",
    dynamicLink = "",
    startDate = null,
    startTime = "",
    type = "online",
    address = "",
    level = "",
    joiningLink = "",
    invitees = [],
    hostName = "",
    createdAt = new Date(),
    createdBy = "",
    hasAskOfferNote = false,
    hostsWebsiteURL = "",
    eventPageURL = "",
    expirationDateTime = null,
    noOfConnections = 0,
    displayImageURL = "",
    sponsors = [],
    featuredCompanies = [],
    postId = "",
    coverImageURL = "",
    agendaURL = "",
    socialMediaPlatform = "",
    promoImageURL = "",
    captionBeforeEventStarts = "",
    captionWhileEventIsHappening = "",
    captionAfterEventHasEnded = "",
    timezone = "",
    socialHandle = "",
    compressedCoverImageURL = "",
    hasPreEventSocialMediaPost = false,
    hasPostEventSocialMediaPost = false,
    preEventPromoImageURL = "",
    postEventPromoImageURL = "",
    currentStep = constants.EVENT_FORMAT_PAGE,
    isCreationInProgress = false,
    sponsorsAnalytics = [],
    preEventPromotionAnalyticData = [],
    postEventPromotionAnalyticData = [],
    facebookPreEventPromotionAnalyticData = [],
    facebookPostEventPromotionAnalyticData = [],
    instagramPreEventPromotionAnalyticData = [],
    instagramPostEventPromotionAnalyticData = [],
    linkedinPreEventPromotionAnalyticData = [],
    linkedinPostEventPromotionAnalyticData = [],
    eventCategory = "",
    multiConnectEventType = "",
    hasSubEvents = false,
    linkedSubEvents = [],
    linkedSessions  = [],
    enableChatroom = false,
    stepper = [],
    parentMultiConnectEventId = "",
    parentSubEventId = "", 
    promoterType = "Partner",
    speakers = [],
    description = "",
    sitemapURL = "",
    noOfChatroomsUsed = 0,
    noOfMessagesSent = 0,
    noOfMessagesSentPreEvent = 0,
    noOfMessagesSentDuringEvent = 0,
    sessionPostCreationAccess = false,
    enableContentFeed = "",
    lastUpdatedAt = null,
    analyticsData = null,
    useAttendeeCollection = true,
    programFiltersEnabled = true,
    preferencesEnabled = true,
    notesEnabled = false,
    enableStartTime = true,
    enableEndTime = true,
  }) {
    (this.id = id || ""),
      (this.name = name || ""),
      (this.startDateTime = startDateTime || null),
      (this.endDateTime = endDateTime || null),
      (this.eventModifiedAt = eventModifiedAt || null),
      (this.linkPrivacy = linkPrivacy || ""),
      (this.hasPrizeDraw = hasPrizeDraw || false),
      (this.minimumCardEntriesForPrizeDraw = minimumCardEntriesForPrizeDraw || 0),
      (this.attendees = attendees),
      (this.prizes = prizes),
      (this.wizardProgress = wizardProgress),
      (this.currentTab = currentTab),
      (this.businessProfileId = businessProfileId),
      (this.dynamicLink = dynamicLink),
      (this.startDate = startDate),
      (this.startTime = startTime),
      (this.type = type),
      (this.address = address),
      (this.level = level),
      (this.joiningLink = joiningLink),
      (this.invitees = invitees),
      (this.hostName = hostName),
      (this.createdAt = createdAt),
      (this.createdBy = createdBy),
      (this.hasAskOfferNote = hasAskOfferNote || false),
      (this.hostsWebsiteURL = hostsWebsiteURL || ""),
      (this.eventPageURL = eventPageURL || ""),
      (this.expirationDateTime = expirationDateTime || null),
      (this.noOfConnections = noOfConnections || 0),
      (this.displayImageURL = displayImageURL || ""),
      (this.sponsors = sponsors || []),
      (this.featuredCompanies = featuredCompanies || []),
      (this.postId = postId || ""),
      (this.coverImageURL = coverImageURL || ""),
      (this.agendaURL = agendaURL || ""),
      (this.socialMediaPlatform = socialMediaPlatform || ""),
      (this.promoImageURL = promoImageURL || ""),
      (this.captionBeforeEventStarts = captionBeforeEventStarts || ""),
      (this.captionWhileEventIsHappening = captionWhileEventIsHappening || ""),
      (this.captionAfterEventHasEnded = captionAfterEventHasEnded || ""),
      (this.timezone = timezone || ""),
      (this.socialHandle = socialHandle || ""),
      (this.compressedCoverImageURL = compressedCoverImageURL || ""),
      (this.hasPreEventSocialMediaPost = hasPreEventSocialMediaPost || false),
      (this.hasPostEventSocialMediaPost = hasPostEventSocialMediaPost || false),
      (this.preEventPromoImageURL = preEventPromoImageURL || ""),
      (this.postEventPromoImageURL = postEventPromoImageURL || ""),
      (this.currentStep = currentStep || constants.EVENT_FORMAT_PAGE),
      (this.isCreationInProgress = isCreationInProgress),
      (this.sponsorsAnalytics = sponsorsAnalytics || []),
      (this.preEventPromotionAnalyticData = preEventPromotionAnalyticData || []),
      (this.postEventPromotionAnalyticData = postEventPromotionAnalyticData || []),
      (this.facebookPreEventPromotionAnalyticData = facebookPreEventPromotionAnalyticData || []),
      (this.facebookPostEventPromotionAnalyticData = facebookPostEventPromotionAnalyticData || []),
      (this.instagramPreEventPromotionAnalyticData = instagramPreEventPromotionAnalyticData || []),
      (this.instagramPostEventPromotionAnalyticData = instagramPostEventPromotionAnalyticData || []),
      (this.linkedinPreEventPromotionAnalyticData = linkedinPreEventPromotionAnalyticData || []),
      (this.linkedinPostEventPromotionAnalyticData = linkedinPostEventPromotionAnalyticData || []),
      (this.eventCategory = eventCategory || ""),
      (this.multiConnectEventType = multiConnectEventType || ""),
      (this.hasSubEvents = hasSubEvents || false),
      (this.linkedSubEvents = linkedSubEvents || []),
      (this.linkedSessions = linkedSessions || []),
      (this.enableChatroom = enableChatroom || false),
      (this.stepper = stepper || []),
      (this.parentMultiConnectEventId = parentMultiConnectEventId || ""),
      (this.parentSubEventId = parentSubEventId || ""),
      (this.promoterType = promoterType || "Partner"),
      (this.speakers = speakers || []),
      (this.description = description || ""),
      (this.sitemapURL = sitemapURL || ""),
      (this.noOfChatroomsUsed = noOfChatroomsUsed || 0),
      (this.noOfMessagesSent = noOfMessagesSent || 0),
      (this.noOfMessagesSentPreEvent  = noOfMessagesSentPreEvent || 0),
      (this.noOfMessagesSentDuringEvent = noOfMessagesSentDuringEvent || 0),
      (this.enableContentFeed = enableContentFeed || false),
      (this.sessionPostCreationAccess = sessionPostCreationAccess || ""),
      (this.lastUpdatedAt = lastUpdatedAt || null),
      (this.analyticsData = analyticsData || null),
      (this.useAttendeeCollection = useAttendeeCollection),
      (this.programFiltersEnabled = programFiltersEnabled),
      (this.preferencesEnabled = preferencesEnabled),
      (this.notesEnabled = notesEnabled),
      (this.enableStartTime = enableStartTime),
      (this.enableEndTime = enableEndTime)
  }

  /* --THIS IS  AN EXACT MAPPING OF MODEL IN FIRESTORE 
    (READ VALUES FROM FIRESTORE AND MAP IT TO OUR MODEL)
    (CONVERT GENERIC OBJECT TO OUT CUSTOM OBJECT)
  */
  static fromFireStore(documentSnapshot) {
    let data = documentSnapshot.data();
    return new Event({
      id: documentSnapshot.id,
      name: data.name || "",
      startDateTime: data.startDateTime?.toDate() || null,
      endDateTime: data.endDateTime?.toDate() || null,
      eventModifiedAt: data.eventModifiedAt?.toDate() || null,
      linkPrivacy: data.linkPrivacy || "",
      hasPrizeDraw: data.hasPrizeDraw || false,
      minimumCardEntriesForPrizeDraw: data.minimumCardEntriesForPrizeDraw || 0,
      attendees: data.attendees?.map((attendee) => Attendee.fromObject(attendee)) || [],
      prizes: data.prizes?.map((prize) => Prize.fromObject(prize)) || [],
      wizardProgress: data.wizardProgress || "",
      currentTab: data.currentTab || 0,
      businessProfileId: data.businessProfileId || "",
      dynamicLink: data.dynamicLink || "",
      type: data.type || "",
      address: data.address || "",
      level: data.level || "",
      joiningLink: data.joiningLink || "",
      invitees: data.invitees?.map((invitee) => Attendee.fromObject(invitee)) || [],
      hostName: data.hostName || "",
      createdAt: data.createdAt?.toDate() || null,
      createdBy: data.createdBy || "",
      hasAskOfferNote: data.hasAskOfferNote || false,
      hostsWebsiteURL: data.hostsWebsiteURL || "",
      eventPageURL: data.eventPageURL || "",
      expirationDateTime: data.expirationDateTime || null,
      noOfConnections: data.noOfConnections || 0,
      displayImageURL: data.displayImageURL || "",
      sponsors: data.sponsors?.map((sponsor) => Sponsor.fromObject(sponsor)) || [],
      featuredCompanies: data.featuredCompanies || [],
      postId: data.postId || "",
      coverImageURL: data.coverImageURL || "",
      agendaURL: data.agendaURL || "",
      socialMediaPlatform: data.socialMediaPlatform || "",
      promoImageURL: data.promoImageURL || "",
      captionBeforeEventStarts: data.captionBeforeEventStarts || "",
      captionWhileEventIsHappening: data.captionWhileEventIsHappening || "",
      captionAfterEventHasEnded: data.captionAfterEventHasEnded || "",
      timezone: data.timezone || "",
      socialHandle: data.socialHandle || "",
      compressedCoverImageURL: data.compressedCoverImageURL || "",
      hasPreEventSocialMediaPost: data.hasPreEventSocialMediaPost || false,
      hasPostEventSocialMediaPost: data.hasPostEventSocialMediaPost || false,
      preEventPromoImageURL: data.preEventPromoImageURL || "",
      postEventPromoImageURL: data.postEventPromoImageURL || "",
      currentStep: data.currentStep || constants.EVENT_FORMAT_PAGE,
      isCreationInProgress: data.isCreationInProgress,    
      sponsorsAnalytics: data.sponsorsAnalytics?.map((item) => SponsorAnalytics.fromObject(item)) || [],
      preEventPromotionAnalyticData: data.preEventPromotionAnalyticData || [],
      postEventPromotionAnalyticData: data.postEventPromotionAnalyticData || [],
      facebookPreEventPromotionAnalyticData: data.facebookPreEventPromotionAnalyticData || [],
      facebookPostEventPromotionAnalyticData: data.facebookPostEventPromotionAnalyticData || [],
      instagramPreEventPromotionAnalyticData: data.instagramPreEventPromotionAnalyticData || [],
      instagramPostEventPromotionAnalyticData: data.instagramPostEventPromotionAnalyticData || [],
      linkedinPreEventPromotionAnalyticData: data.linkedinPreEventPromotionAnalyticData || [],
      linkedinPostEventPromotionAnalyticData: data.linkedinPostEventPromotionAnalyticData || [],
      eventCategory: data.eventCategory || "",
      multiConnectEventType: data.multiConnectEventType || "",
      hasSubEvents: data.hasSubEvents || false,
      linkedSubEvents: data.linkedSubEvents || [],
      linkedSessions: data.linkedSessions || [],
      enableChatroom: data.enableChatroom || false,
      stepper: data.stepper || [],
      parentMultiConnectEventId: data.parentMultiConnectEventId || "",
      parentSubEventId: data.parentSubEventId || "",
      promoterType: data.promoterType || "Partner",
      speakers: data.speakers?.map((item) => Speaker.fromEventObject(item)) || [],
      description: data.description || "",
      sitemapURL:data.sitemapURL || "",
      noOfChatroomsUsed: data.noOfChatroomsUsed || 0,
      noOfMessagesSent: data.noOfMessagesSent || 0,
      noOfMessagesSentPreEvent: data.noOfMessagesSentPreEvent || 0,
      noOfMessagesSentDuringEvent: data.noOfMessagesSentDuringEvent || 0,
      enableContentFeed: data.enableContentFeed || false,
      sessionPostCreationAccess: data.sessionPostCreationAccess || "",
      lastUpdatedAt: data.lastUpdatedAt?.toDate() || null,
      analyticsData: data.analyticsData || null,
      useAttendeeCollection: data.useAttendeeCollection,
      programFiltersEnabled: data.programFiltersEnabled,
      preferencesEnabled: data.preferencesEnabled,
      notesEnabled: data.notesEnabled,
      enableStartTime: data.enableStartTime,
      enableEndTime: data.enableEndTime,
    });
  }

  //THIS IS DATA THAT HAS TO BE SENT TO FIRESTORE (WILL ONLY INCLUDE FIELDS THAT ARE SUPPOSED TO BE IN FIRESTORE DOC) (CONVERT CUSTOM OBJECT TO GENERIC OBJECT)
  toFireStore() {
    let configFields = {};
    if (this.programFiltersEnabled !== undefined) {
      configFields["programFiltersEnabled"] = this.programFiltersEnabled;
    }
    if (this.notesEnabled !== undefined) {
      configFields["notesEnabled"] = this.notesEnabled;
    }
    if (this.preferencesEnabled !== undefined) {
      configFields["preferencesEnabled"] = this.preferencesEnabled;
    }
    if (this.useAttendeeCollection !== undefined) {
      configFields["useAttendeeCollection"] = this.useAttendeeCollection;
    }

    return {
      ...configFields,
      name: this.name || "",
      startDateTime: this.startDateTime || null,
      endDateTime: this.endDateTime || null,
      eventModifiedAt: new Date(),
      linkPrivacy: this.linkPrivacy || "",
      hasPrizeDraw: this.hasPrizeDraw || false,
      minimumCardEntriesForPrizeDraw: this.minimumCardEntriesForPrizeDraw || 0,
      attendees: this.attendees?.map((attendee) => attendee.toObject()) || [],
      prizes: this.prizes?.map((prize) => prize.toObject()) || [],
      wizardProgress: this.wizardProgress || "",
      currentTab: this.currentTab || 0,
      businessProfileId: this.businessProfileId || "",
      dynamicLink: this.dynamicLink || "",
      type: this.type || "",
      address: this.address || "",
      level: this.level || "",
      joiningLink: this.joiningLink || "",
      invitees: this.invitees?.map((invitee) => invitee.toObject()) || [],
      hostName: this.hostName || "",
      createdAt: this.createdAt || null,
      createdBy: this.createdBy || "",
      hasAskOfferNote: this.hasAskOfferNote || false,
      hostsWebsiteURL: this.hostsWebsiteURL || "",
      eventPageURL: this.eventPageURL || "",
      expirationDateTime: this.expirationDateTime || null,
      noOfConnections: this.noOfConnections || 0,
      displayImageURL: this.displayImageURL || "",
      sponsors: this.sponsors?.map((sponsor) => sponsor.toEventObject()) || [],
      featuredCompanies: this.featuredCompanies || [],
      postId: this.postId || "",
      coverImageURL: this.coverImageURL || "",
      agendaURL: this.agendaURL || "",
      socialMediaPlatform: this.socialMediaPlatform || "",
      promoImageURL: this.promoImageURL || "",
      captionBeforeEventStarts: this.captionBeforeEventStarts || "",
      captionWhileEventIsHappening: this.captionWhileEventIsHappening || "",
      captionAfterEventHasEnded: this.captionAfterEventHasEnded || "",
      timezone: this.timezone || "",
      socialHandle: this.socialHandle || "",
      compressedCoverImageURL: this.compressedCoverImageURL || "",
      hasPreEventSocialMediaPost: this.hasPreEventSocialMediaPost || false,
      hasPostEventSocialMediaPost: this.hasPostEventSocialMediaPost || false,
      preEventPromoImageURL: this.preEventPromoImageURL || "",
      postEventPromoImageURL: this.postEventPromoImageURL || "",
      currentStep: this.currentStep || constants.EVENT_FORMAT_PAGE,
      isCreationInProgress: this.isCreationInProgress,
      sponsorsAnalytics: this.sponsorsAnalytics?.map((item) => item.toObject()) || [],
      preEventPromotionAnalyticData: this.preEventPromotionAnalyticData || [],
      postEventPromotionAnalyticData: this.postEventPromotionAnalyticData || [],
      facebookPreEventPromotionAnalyticData: this.facebookPreEventPromotionAnalyticData || [],
      facebookPostEventPromotionAnalyticData: this.facebookPostEventPromotionAnalyticData || [],
      instagramPreEventPromotionAnalyticData: this.instagramPreEventPromotionAnalyticData || [],
      instagramPostEventPromotionAnalyticData: this.instagramPostEventPromotionAnalyticData || [],
      linkedinPreEventPromotionAnalyticData: this.linkedinPreEventPromotionAnalyticData || [],
      linkedinPostEventPromotionAnalyticData: this.linkedinPostEventPromotionAnalyticData || [],
      eventCategory: this.eventCategory || "",
      multiConnectEventType: this.multiConnectEventType || "",
      hasSubEvents: this.hasSubEvents || false,
      linkedSubEvents: this.linkedSubEvents || [],
      linkedSessions: this.linkedSessions || [],
      enableChatroom: this.enableChatroom || false,
      stepper: this.stepper || [],
      parentMultiConnectEventId: this.parentMultiConnectEventId || "",
      parentSubEventId: this.parentSubEventId || "",
      promoterType: this.promoterType || "Partner",
      speakers: this.speakers?.map((speaker) => speaker.toEventObject()) || [],
      description: this.description || "",
      sitemapURL: this.sitemapURL || "",
      noOfChatroomsUsed: this.noOfChatroomsUsed || 0,
      noOfMessagesSent: this.noOfMessagesSent || 0,
      noOfMessagesSentPreEvent: this.noOfMessagesSentPreEvent || 0,
      noOfMessagesSentDuringEvent: this.noOfMessagesSentDuringEvent || 0,
      enableContentFeed: this.enableContentFeed || false,
      sessionPostCreationAccess: this.sessionPostCreationAccess || "",
      lastUpdatedAt: this.lastUpdatedAt || null,
      analyticsData: this.analyticsData || null,
      useAttendeeCollection: this.useAttendeeCollection,
      enableStartTime: this.enableStartTime,
      enableEndTime: this.enableEndTime,
    };
  }

  //Save the document to firestore
  async save() {
    try {
      await setEventDoc(this.id, this.toFireStore(), { merge: true });
      if (this.linkPrivacy === 'public') {
        await this.generatePublicLink();
        await updateEventDoc(this.id, {
          'dynamicLink': this.dynamicLink
        });
      }
      if(this.enableChatroom) {
        await updateDocByName("chat_rooms", this.id, {
          "groupName": this.name,
          "groupImage": this.displayImageURL,
        });
      }
    } catch (error) {
      console.log("Error occurred while adding event to firestore - ", error.message);
    }
  }

  getLinkRegistrants() {
    let registrants = [];

    this.attendees.forEach((attendee) => {
      if (attendee.businessCardId != "") {
        getBusinessCardsDoc(attendee.businessCardId)
          .then((doc) => {
            registrants.push(doc.data());
          });
      }
    });

    return registrants;
  }

  getStatus() {
    let now = new Date();
    if (this.eventCategory == 'travel') {
      if (!this.startDateTime || !this.endDateTime) {
        return "Incomplete";
      }
    }
    //Calculate activation and expiration times
    let eventActivationDateTime = this.getEventActivationDateTime();

    let eventExpirationDateTime = this.getEventExpirationDateTime();

    if(!this.isCreationInProgress){
      if (eventActivationDateTime <= now && now <= eventExpirationDateTime) return "Active";
      else if (now >= eventExpirationDateTime) return "Past";
      else return "Upcoming";
    }else{
      return "Incomplete";
    }
  }

  async remove() {
    try {
      // if(this.getStatus() == 'Upcoming'){

      //   //Update credits in business profile
      //   batch.update(firebase
      //     .firestore()
      //     .collection("business_profiles")
      //     .doc(store.getters.selectedBusinessProfileId), {multiConnectCredits: firebase.firestore.FieldValue.increment(1)});

      // }
      await deleteEventDoc(this.id);
      return true;
    } catch (error) {
      console.log("Error occurred while deleting event - ", error.message);
      return false;
    }
  }

  async generatePublicLink() {
    //Create an event id
    if (this.id == "") {
      let eventDocRef = doc(eventCollectionRef);
      this.id = eventDocRef.id;
    }
    let deepLink = `${Utility.webAppLinkPrefix()}event/${this.id}?name=${this.name}`;
    this.dynamicLink = encodeURI(deepLink);
  }

  //Link expiry info
  getInfo() {
    let info = "";
    if (this.getStatus() == "Active") {
      let endDate = this.getEventExpirationDateTime().toDateString();
      endDate = endDate.substring(0, 3) + ", " + endDate.substring(3, endDate.length);
      let endTime = new Date(this.endDateTime).toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });

      info = `Link expires on <br/>  ${endDate} at ${endTime}`;
    }

    return info;
  }

  getStatusColor() {
    if (this.getStatus() == "Active") return "secondary";
    else if (this.getStatus() == "Upcoming") return "#cfe3e5";
    else if (this.getStatus() == "Incomplete") return "yellow lighten-3";
    else return "grey lighten-3";
  }

  getStatusTextColor() {
    if (this.getStatus() == "Active") return "white";
    else if (this.getStatus() == "Upcoming") return "secondary lighten-3";
    else if (this.getStatus() == "Incomplete") return "amber";
    else return "grey";
  }

  getEventExpirationDateTime() {
    // let eventExpirationDateTime = new Date(this.endDateTime);
    // eventExpirationDateTime.setHours(this.endDateTime.getHours() +  72);
    if(this.endDateTime){

   
     //If user hasn't selected a timezone, set a default value based on browsers timezone
    if (!this.timezone) {
      this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    let eventExpirationDateTime = Utility.addWorkDays(new Date(this.endDateTime).toLocaleString("en-US", {
      timeZone: this.timezone
    }), 3);

    // let eventExpirationDateTime = Utility.addWorkDays(new Date(this.endDateTime), 3);

    return new Date(eventExpirationDateTime);
    }else return "";

  }

  getEventActivationDateTime() {
    let eventActivationDateTime = new Date(this.startDateTime);
    // eventActivationDateTime.setHours(this.startDateTime.getHours() - 24);
    return new Date(eventActivationDateTime);
  }

  //Formatted Dates
  getFormattedEventActivationDateTime() {
    let eventActivationDateTimeString = "";

    if(this.startDateTime && this.endDateTime){
    //If user hasn't selected a timezone, set a default value based on browsers timezone
    if (!this.timezone) {
      this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }


    eventActivationDateTimeString =
      new Intl.DateTimeFormat("en-US", { weekday: "short", timeZone: this.timezone }).format(
        this.getEventActivationDateTime()
      ) +
      ", " +
      new Intl.DateTimeFormat("en-US", { dateStyle: "medium", timeZone: this.timezone }).format(
        this.getEventActivationDateTime()
      );
       
      if(!this.hasSubEvents){
        eventActivationDateTimeString = eventActivationDateTimeString +    " at " +
        new Intl.DateTimeFormat("en-US", {
          timeStyle: "short",
          timeZone: this.timezone,
        }).format(this.getEventActivationDateTime());
      }
   
    }

    return eventActivationDateTimeString;
  }

  getFormattedEventExpirationDateTime() {
    let eventExpirationDateTimeString = "";

    if(this.startDateTime && this.endDateTime){
    //If user hasn't selected a timezone, set a default value based on browsers timezone
    if (!this.timezone) {
      this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    eventExpirationDateTimeString =
      new Intl.DateTimeFormat("en-US", { weekday: "short" }).format(
        this.getEventExpirationDateTime()
      ) +
      ", " +
      new Intl.DateTimeFormat("en-US", { dateStyle: "medium"}).format(
        this.getEventExpirationDateTime()
      );

      if(!this.hasSubEvents){
        eventExpirationDateTimeString = eventExpirationDateTimeString +
        " at " +
        new Intl.DateTimeFormat("en-US", {
          timeStyle: "short",
         
        }).format(this.getEventExpirationDateTime());
      }
    }

    return eventExpirationDateTimeString;
  }

  getFormattedEventStartDate() {
    let startDateTimeString = "";
    if(this.startDateTime && this.endDateTime){

     //If user hasn't selected a timezone, set a default value based on browsers timezone
    if (!this.timezone) {
      this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    startDateTimeString =
      new Intl.DateTimeFormat("en-US", { weekday: "short", timeZone: this.timezone }).format(this.startDateTime) +
      ", " +
      new Intl.DateTimeFormat("en-US", { dateStyle: "medium", timeZone: this.timezone  }).format(this.startDateTime);
    }

    return startDateTimeString;
  }

  getFormattedEventEndDate() {
    let endDateTimeString = "";

    if(this.startDateTime && this.endDateTime){

     //If user hasn't selected a timezone, set a default value based on browsers timezone
     if (!this.timezone) {
      this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    endDateTimeString =
      new Intl.DateTimeFormat("en-US", { weekday: "short", timeZone: this.timezone }).format(this.endDateTime) +
      ", " +
      new Intl.DateTimeFormat("en-US", { dateStyle: "medium", timeZone: this.timezone  }).format(this.endDateTime);
    }

    return endDateTimeString;
  }
  
  async saveEventTriggers(triggers, fieldType) {
    triggers = triggers.map((trigger) => trigger.toFireStore());

    let db = getFirestore();
    let batch = writeBatch(db);

    //Get existing trigger documents for the event for deletion
    const eventTriggers = await getQueryByCollectionName("triggers", where("multiconnectId", "==", this.id));

    eventTriggers.forEach((doc) => {
      if (doc.data().fieldType == fieldType) batch.delete(doc.ref);
    });

    //Save new trigger documents
    triggers.forEach((document) => {
      let docRef = doc(getCollectionRef("triggers"));
      batch.set(docRef, document);
    });

    await batch.commit();
  }

  async sendEventCreationConfirmationEmail() {
    let userProfile = store.getters.userProfile;

    const sendEventcreationConfirmation = getHttpsCallable("sendEventCreationConfirmation");
    let result = await sendEventcreationConfirmation({
      email: userProfile.email,
      firstName: userProfile.firstName,
      eventName: this.name,
      dynamicLink: "https://business.pappyon.com/editMultiConnect/" + this.id,
      eventDateTime: this.getFormattedEventStartDate(),
      businessPortalLinkInvitationURL: "https://business.pappyon.com/editMultiConnect/" + this.id + "?tab=2",
      businessPortalLinkRegistrantsURL: "https://business.pappyon.com/editMultiConnect/" + this.id + "?tab=4",
    });
    return result;
  }

  generateEventId() {

    //Create an event id
    if (this.id == "") {
      let eventDocRef = doc(eventCollectionRef);
      this.id = eventDocRef.id;
    }
  }

  async batchSave(post) {
    try {
      const db = getFirestore();
      let batch = writeBatch(db);
      batch.update(eventDocRef(this.id), this.toFireStore());
      batch.set(postDocRef(this.postId), post.toFireStore());
      await batch.commit();
    } catch (error) {
      console.log("Error occurred while saving post and MC event: ", error);
    }
  }

  async removeSpeaker(speaker, associatedSessionId, eventName ) {
    try{
    
    //Find index of the speaker
    let index = this.speakers.findIndex(
      (item) => item.speakerId == speaker.speakerId
    );

   //Delete speaker from array or update speaker's associated speaker sessions
   if (speaker.associatedSpeakerSessions.length == 1) {
    //Remove the speaker from the event's list of speakers
    this.speakers.splice(index, 1);
  } else {
    //Update the sessions of speaker to remove current session id
    this.speakers[index].associatedSpeakerSessions =
      this.speakers[index].associatedSpeakerSessions.filter(
        (sessionId) => sessionId != associatedSessionId.id
      );
  }

    //Save the event
    this.save();

    //Check if speaker had opted-in to the event
    // let hasOptedIn = this.attendees.some(
    //   (attendee) => attendee.uid == speaker.uid
    // );

    // if (hasOptedIn) {
    //   let db = firebase.firestore();
    //   var batch = db.batch();

    //   // Send an in-app notification to the speaker
    //   batch.set(db.collection("notifications").doc(), {
    //     uid: speaker.uid,
    //     businessCardId: speaker.businessCardId,
    //     type: "SPEAKER_REMOVED_FROM_SESSION",
    //     createdOn: new Date(),
    //     multiConnectDocId: this.id,
    //     message:
    //       "You have been removed from " +
    //       eventName +
    //       " as a speaker.",
    //   });
    //   batch.update(
    //     db
    //       .collection("business_cards")
    //       .doc(speaker.businessCardId),
    //     {
    //       noOfNewNotifications: firebase.firestore.FieldValue.increment(1),
    //     }
    //   );
    //   await batch.commit();
    // } else {
    //   //Send an email to the speaker
    //   this.sendAccessRevokedEmail(this.name, "speaker", speaker);
    // }
    return {success: true};
  }catch(error){
      console.log("Error occurred while removing speaker: ", error);
  }
  }
  async sendAccessRevokedEmail(eventName, role, speaker) {
    try {
      const sendAccessRevokedEmailNotification = getHttpsCallable("sendAccessRevokedEmailNotificationToInvitee");
      let result = await sendAccessRevokedEmailNotification({
        email: speaker.invitedEmail,
        eventName: eventName,
        firstName: speaker.firstName,
        lastName: speaker.lastName,
        role: role,
      });
      return result;
    } catch (error) {
      console.log(
        "Error occurred while sending access revoked email to user: ",
        error
      );
    }
  }

  async deleteSession(sessionToBeDeletedId, associatedSubEvent) {
    try {
      //Delete the session
      // sessionToBeDeleted.remove();
      await deleteEventDoc(sessionToBeDeletedId);

      //Update linked sessions for the parent sub event
      associatedSubEvent.linkedSessions =
      associatedSubEvent.linkedSessions.filter(
          (sessionId) => sessionId != sessionToBeDeletedId
        );

      //Save sub-event
      associatedSubEvent.save();
    } catch (error) {
      console.log("Error occurred while deleting session: ", error);
    }

    //Start: Delete the speakers associated with this session from the event
    if (this.getNoOfSpeakers(sessionToBeDeletedId) >= 1) {
      console.log("removing speakers...");
      //Delete speakers and the session
      let speakers = this.getSpeakers(sessionToBeDeletedId);
      await Promise.all(
        speakers.map(async (speaker) => {
          console.log("speaker: ", speaker.uid);

          await this.removeSpeaker(
            speaker,
            sessionToBeDeletedId,
            associatedSubEvent.name
          );
        })
      );
    }
    //End: Delete the speakers associated with this session from the event

    //Start: Remove session from this list if they were removed by the user
    let removedSessionIndex = associatedSubEvent.linkedSessions.findIndex(
      (session) => session.id == sessionToBeDeletedId
    );
    associatedSubEvent.linkedSessions.splice(removedSessionIndex, 1);
    //End: Remove speaker from this list if they were removed by the user


  }

  getNoOfSpeakers(sessionId) {
    let speakers = this.getSpeakers(sessionId);
    return speakers.length;
  }
  getSpeakers(sessionId) {
    let speakers = this.speakers.filter(
      (speaker) =>
        speaker.associatedSpeakerSessions.length > 0 &&
        speaker.associatedSpeakerSessions.includes(sessionId)
    );
    return speakers;
  }




}

//
